module.exports = __webpack_public_path__ + "static/live-coding-the-hive-da2ba11d19dd2d58d7f01bd1e270f2df.png";